import React from 'react';
import { Line } from 'react-chartjs-2';
import styled from 'styled-components';

const ChartsContainer = styled.div`  
  width: 100%;  
  border-radius: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
`;

const ChartWrapper = styled.div`  
  width: 100%; 
  height: 300px;
`;

const H2txet = styled.h2`
  font-size: 1rem; 
  font-weight: bold;
  text-align: center;
`;

const ChartComponent = ({ data }) => {
  const chartData = data && {
    labels: data.map(item => item.hour),
    datasets: [
      {
        label: '収穫成功数',
        data: data.map(item => item.eventCounts.ok || 0),
        fill: false,
        backgroundColor: '#006331',
        borderColor: '#006331',
      },
      {
        label: '収穫見送り数',
        data: data.map(item => item.eventCounts.ng || 0),
        fill: false,
        backgroundColor: 'blue',
        borderColor: 'blue',
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        labels: {
          color: 'black',
        },
      },
      datalabels: { 
        display: false,
      }, 
    },
    scales: {
      x: {
        title: {
          display: true,
          text: '時間',
        },
      },
      y: {
        title: {
          display: true,
          text: 'イベント数',
        },
        beginAtZero: true,
      },
    },
    maintainAspectRatio: false, // ここを追加
  };

  return (
    <ChartsContainer>
      <H2txet>
        ロボット収穫状況　過去24時間
      </H2txet>
      <div style={{ position: 'relative' }}>
        <ChartWrapper>
          <Line data={chartData} options={options} />
        </ChartWrapper>
      </div>
    </ChartsContainer>
  );
};

export default ChartComponent;
